var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkposLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 912 968",
    width: 912,
    height: 968,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pinkpos-logo_V2-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 1805,
    y1: 9.3,
    x2: 1805,
    y2: 965.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff71bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #fff }\n\t\t.s1 { fill: url(#g1) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1843638042192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m388.2 496.8v-131c0-1.9 1.6-3.6 3.6-3.6h20.8c1.9 0 3.5 1.6 3.5 3.6v130.9c0 1.9-1.5 3.6-3.5 3.6h-20.8c-2 0-3.6-1.6-3.6-3.5zm14-153.4c-10.9 0-18.7-7.9-18.7-18.7 0-10.6 7.9-18.3 18.7-18.3 10.7 0 18.5 7.7 18.5 18.3 0 10.8-7.8 18.7-18.5 18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m555 499.9c-1.9 0-3.6-1.6-3.6-3.6v-78c0-21.3-12.9-35.1-33.1-35.1-21.1 0-38.3 16.6-38.3 37v76.2c0 1.9-1.5 3.6-3.6 3.6h-20.8c-1.9 0-3.6-1.6-3.6-3.6v-130.4c0-1.8 1.6-3.5 3.6-3.5h20.8c1.9 0 3.6 1.6 3.6 3.5v8.6c0 1 1.3 1.4 1.9 0.6 10-11.4 23.7-17.6 39.2-17.6 34.2 0 58.1 25 58.1 60.7v78c0 1.9-1.5 3.6-3.5 3.6 0 0-20.7 0-20.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m212.2 556.8v-191c0-1.9 1.5-3.6 3.5-3.6h20.9c1.9 0 3.5 1.6 3.5 3.6v10c0 1 1.2 1.4 1.9 0.7 10.8-12.6 26.7-19.5 45.7-19.5 40.6 0 71.2 31.8 71.2 74.1 0 42.4-30.5 74.4-70.9 74.4-20.1 0-37.1-7.8-47.9-21.5v72.8c0 1.9-1.6 3.6-3.6 3.6h-20.8c-2 0-3.5-1.6-3.5-3.6zm73-174c-26.3 0-46 20.8-46 48.3 0 27.7 19.8 48.7 46 48.7 26.1 0 45.8-21 45.8-48.7 0-27.9-19.2-48.3-45.8-48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m692.6 498.9l-53-56.3c-0.5-0.7-1.6-0.2-1.6 0.7v53.5c0 1.9-1.6 3.6-3.6 3.6h-20.8c-1.9 0-3.6-1.6-3.6-3.6v-191c0-1.9 1.6-3.6 3.6-3.6h20.8c1.9 0 3.6 1.6 3.6 3.6v108.9c0 0.8 1 1.3 1.6 0.6l51.8-51.7c0.8-0.8 1.9-1.3 3.1-1.3h32.5c1.3 0 1.8 1.5 0.9 2.3l-63.8 62c-1.1 1.1-1.1 2.9-0.1 4l65.4 67.3c0.8 0.9 0.2 2.3-1 2.3h-32.5c-1.3 0.1-2.5-0.4-3.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m761.1 408.9v-46.1c0-0.9 0.7-1.6 1.6-1.6h18.2c5.9 0 10.7 1.7 14 4.9 2.6 2.7 4 6.3 4 10.6 0 9.2-7.3 15.4-18 15.4h-10.1c-0.8 0-1.4 0.7-1.4 1.5v15.2c0 0.8-0.6 1.4-1.4 1.4h-5.4c-0.8 0-1.5-0.6-1.5-1.4zm19.8-24.3c6.1 0 9.7-2.9 9.7-7.8 0-4.9-3.5-7.9-9.7-7.9h-10.1c-0.8 0-1.4 0.6-1.4 1.4v12.8c0 0.8 0.6 1.5 1.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m834.5 411.9c-15.6 0-26.4-10.8-26.4-26.2 0-15.2 11.1-26.2 26.4-26.2 15.3 0 26.4 11 26.4 26.2 0 15.4-10.9 26.2-26.4 26.2zm0-44.7c-10.7 0-18 7.6-18 18.5 0 10.8 7.5 18.6 18 18.6 10.6 0 18-7.7 18-18.6-0.1-10.9-7.4-18.5-18-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m877.7 392.6c0.6 0 1.3 0.6 1.3 1.2 0.5 7.2 5.3 10.1 13 10.1 6.9 0 11.1-2.7 11.1-7.2 0-5.1-4.9-6.2-12.8-7.4-9.2-1.4-19.1-3.9-19.1-14.6 0-9.2 7.4-14.9 19.2-14.9 11.8 0 19.4 5.7 20 16.6 0 0.8-0.6 1.3-1.4 1.3h-5.7c-0.7 0-1.2-0.5-1.3-1.2-0.6-5.4-4.8-9.2-11.7-9.2-6.8 0-10.7 2.5-10.7 7 0 5 4.9 6.1 12.4 7.2 8.1 1.3 19.4 3.1 19.4 14.8 0 9.4-7.5 15.2-19.7 15.2-12.7 0-20.7-5.9-21.3-17.5 0-0.7 0.6-1.3 1.2-1.3l6.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m24.8 967.7c-13.6 0-24.8-11.2-24.8-24.7v-500.3c0.4-249.8 208.4-452 460.5-442.4 194.1 7.5 356.8 141.3 408.5 320.9h-125c-48.4-118.8-165-202.6-300.9-202.6-179 0-324.8 145.8-324.8 324.8 0 179.1 145.8 324.8 324.8 324.8 171.5 0 312.4-133.7 324-302.3h118.4c-12.1 233.8-205.8 420.3-442.4 420.3-85.4 0-168.6-24.4-240.1-70.8l-66.9-43.3c-7.7-5-17.8 0.4-17.8 9.7v161.2c0 13.5-11.2 24.7-24.7 24.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1843637977824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1757.6 496.8v-131c0-1.9 1.5-3.6 3.5-3.6h20.8c1.9 0 3.6 1.6 3.6 3.6v130.9c0 1.9-1.6 3.6-3.6 3.6h-20.8c-2 0-3.5-1.6-3.5-3.5zm14-153.4c-10.9 0-18.7-7.9-18.7-18.7 0-10.6 7.9-18.3 18.7-18.3 10.7 0 18.5 7.7 18.5 18.3 0 10.8-7.8 18.7-18.5 18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1924.3 499.9c-1.9 0-3.5-1.6-3.5-3.6v-78c0-21.3-13-35.1-33.1-35.1-21.1 0-38.3 16.6-38.3 37v76.2c0 1.9-1.6 3.6-3.6 3.6h-20.9c-1.9 0-3.6-1.6-3.6-3.6v-130.4c0-1.8 1.6-3.5 3.6-3.5h20.9c1.9 0 3.6 1.6 3.6 3.5v8.6c0 1 1.2 1.4 1.9 0.6 9.9-11.4 23.7-17.6 39.2-17.6 34.2 0 58.1 25 58.1 60.7v78c0 1.9-1.6 3.6-3.6 3.6 0 0-20.7 0-20.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1581.5 556.8v-191c0-1.9 1.6-3.6 3.6-3.6h20.8c1.9 0 3.6 1.6 3.6 3.6v10c0 1 1.2 1.4 1.9 0.7 10.8-12.6 26.7-19.5 45.6-19.5 40.7 0 71.3 31.8 71.3 74.1 0 42.4-30.5 74.4-71 74.4-20 0-37-7.8-47.8-21.5v72.8c0 1.9-1.6 3.6-3.6 3.6h-20.8c-2 0-3.6-1.6-3.6-3.6zm73.1-174c-26.3 0-46 20.8-46 48.3 0 27.7 19.8 48.7 46 48.7 26 0 45.7-21 45.7-48.7 0-27.9-19.1-48.3-45.7-48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2062 498.9l-53-56.3c-0.6-0.7-1.7-0.2-1.7 0.7v53.5c0 1.9-1.5 3.6-3.5 3.6h-20.9c-1.9 0-3.5-1.6-3.5-3.6v-191c0-1.9 1.5-3.6 3.5-3.6h20.8c1.9 0 3.6 1.6 3.6 3.6v108.9c0 0.8 1 1.3 1.7 0.6l51.8-51.7c0.7-0.8 1.8-1.3 3.1-1.3h32.5c1.2 0 1.8 1.5 0.9 2.3l-63.8 62c-1.1 1.1-1.1 2.9-0.1 4l65.3 67.3c0.8 0.9 0.2 2.3-1 2.3h-32.5c-1.2 0.1-2.4-0.4-3.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m2130.5 408.9v-46.1c0-0.9 0.6-1.6 1.5-1.6h18.3c5.9 0 10.7 1.7 13.9 4.9 2.7 2.7 4 6.3 4 10.6 0 9.2-7.2 15.4-17.9 15.4h-10.1c-0.8 0-1.5 0.7-1.5 1.5v15.2c0 0.8-0.6 1.4-1.3 1.4h-5.5c-0.8 0-1.4-0.6-1.4-1.3zm19.8-24.4c6 0 9.7-2.9 9.7-7.8 0-4.9-3.6-7.9-9.7-7.9h-10.1c-0.8 0-1.5 0.6-1.5 1.4v12.8c0 0.8 0.7 1.5 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m2203.8 411.9c-15.5 0-26.3-10.8-26.3-26.2 0-15.2 11.1-26.2 26.3-26.2 15.3 0 26.4 11 26.4 26.2 0 15.4-10.9 26.2-26.4 26.2zm0-44.7c-10.6 0-18 7.6-18 18.5 0 10.8 7.6 18.6 18 18.6 10.6 0 18.1-7.7 18.1-18.6-0.1-10.9-7.5-18.5-18.1-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m2247 392.6c0.7 0 1.4 0.6 1.4 1.2 0.4 7.2 5.2 10.1 12.9 10.1 6.9 0 11.1-2.7 11.1-7.2 0-5.1-4.8-6.2-12.8-7.4-9.2-1.4-19.1-3.9-19.1-14.6 0-9.2 7.4-14.9 19.2-14.9 11.8 0 19.4 5.7 20 16.6 0 0.8-0.6 1.3-1.4 1.3h-5.6c-0.7 0-1.3-0.5-1.4-1.2-0.5-5.4-4.8-9.2-11.7-9.2-6.8 0-10.7 2.5-10.7 7 0 5 4.9 6.1 12.4 7.2 8.2 1.3 19.4 3.1 19.4 14.8 0 9.4-7.5 15.2-19.6 15.2-12.7 0-20.8-5.9-21.4-17.5 0-0.7 0.6-1.3 1.3-1.3l6-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1394.1 967.7c-13.5 0-24.8-11.2-24.8-24.7l0.1-500.3c0.3-249.8 208.4-452 460.4-442.4 194.1 7.5 356.8 141.3 408.5 320.9h-124.9c-48.4-118.8-165.1-202.6-300.9-202.6-179.1 0-324.8 145.8-324.8 324.8 0 179.1 145.7 324.8 324.8 324.8 171.4 0 312.3-133.7 323.9-302.3h118.5c-12.2 233.8-205.8 420.3-442.4 420.3-85.5 0-168.6-24.4-240.1-70.8l-66.9-43.3c-7.8-5-17.8 0.4-17.8 9.7v161.2c0 13.5-11.2 24.7-24.8 24.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkposLogo);
export default __webpack_public_path__ + "static/media/pinkpos-logo.18bbdf232112127f9517d8f0313c359d.svg";
export { ForwardRef as ReactComponent };